import { useLayoutEffect } from "react";
import { Link } from "@tanstack/react-router";
import { ArrowRightIcon } from "lucide-react";

import { SiteFooter } from "@/components/brand/site-footer";
import { SiteHeader } from "@/components/brand/site-header";
import { brand } from "@/lib/brand";
import { acquireForcedLightTheme } from "@/lib/theme";
import { cn } from "@/lib/utils";

const primaryCtaClassName = cn(
  "inline-flex h-14 min-w-48 touch-manipulation items-center justify-center gap-2 rounded-xl",
  "bg-primary px-8 text-base font-semibold text-primary-foreground shadow-[0_1px_3px_hsla(0,0%,0%,.2)]",
  "transition-colors hover:bg-primary/90 focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:outline-none",
);

const secondaryCtaClassName = cn(
  "inline-flex h-14 min-w-48 touch-manipulation items-center justify-center gap-2 rounded-xl",
  "border-2 border-primary/30 bg-card px-8 text-base font-medium text-primary",
  "transition-colors hover:border-primary/50 hover:bg-bloom-blue-soft focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:outline-none",
);

export function LandingPage() {
  useLayoutEffect(() => acquireForcedLightTheme(), []);

  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <SiteHeader showThemeToggle={false} />
      <main className="relative flex flex-1 flex-col">
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--bloom-blue-soft)_0%,_transparent_55%)]"
        />
        <div className="relative mx-auto flex w-full max-w-lg flex-1 flex-col justify-center px-6 py-16 sm:max-w-xl sm:px-8 sm:py-24">
          <p className="text-sm font-medium tracking-wide text-primary uppercase">
            Bloom Integrated Health
          </p>
          <h1 className="mt-4 font-heading text-4xl leading-tight font-semibold tracking-tight text-foreground sm:text-5xl">
            Oops, feeling lost?
          </h1>
          <p className="mt-4 max-w-prose text-base leading-relaxed text-muted-foreground sm:text-lg">
            Start the short survey, or learn more about us.
          </p>
          <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <Link to="/get-started" className={primaryCtaClassName}>
              Get started
              <ArrowRightIcon className="size-5" aria-hidden />
            </Link>
            <a
              href={brand.aboutUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={secondaryCtaClassName}
            >
              More about us
            </a>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
